export const AppConfig = {
  isProduction: import.meta.env.PROD,
  apiBaseUrl: '/api',
} as const;
